<template>
  <div>
    <loader v-if="loading" label="Carregando contas..." />

    <form-group
      :columns="12"
      label="Conta"
      :required="true"
    >
      <select class="form-select" v-model="account" required>
        <option disabled value="">Selecione</option>
        <option
          v-for="account in magaluAccounts"
          :key="account.identifier"
          :value="account.identifier"
        >
          {{ account.nickname }} 
        </option>
      </select>
    </form-group>
  </div>
</template>

<script>
import api from '@/api'
import FormGroup from '@/components/template/FormGroup'
import Loader from '@/components/template/Loader'

export default {
  data: () => ({
    account: '',
    magaluAccounts: [],
    loading: false,
    submitted: false
  }),
  async mounted () {
    this.loading = true
    try {
      const { items } = await api.magalu.getAccounts({})
      this.magaluAccounts = items
      if (this.magaluAccounts.length === 1) this.account = this.magaluAccounts[0].identifier
    } finally {
      this.loading = false
    }
  },
  methods: {
    async syncOrder (data) {
      this.submitted = true
      if (!this.account || !this.selectedAuthorizedShop) {
        return
      }

      await api.magalu.syncOrder(
        data.type,
        data.identifier,
        data.code,
        this.account
      )
    }
  },
  components: {
    FormGroup,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// SyncDialog.vue?12ab638e